export const blockIconsActivitiesSportsVolleyballNew = (
	<span className='material-symbols-outlined'>sports_volleyball</span>
);
